module.exports = __webpack_public_path__ + "static/03-a3dc30d4bde4eb4c8a2060d8fce14f99.jpg";